export interface UnsupportedFigure {
  path: string;
  figure: string;
}

export interface TextSegment {
  text: string;
  flagged: boolean;
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/** Splits text so figures that are not in the source data can be marked. The sentence stays intact. */
export function highlightSegments(text: string, figures: string[]): TextSegment[] {
  const unique = [...new Set(figures.filter((figure) => figure.length > 0))].sort(
    (left, right) => right.length - left.length,
  );
  if (unique.length === 0 || text.length === 0) return [{ text, flagged: false }];

  const pattern = new RegExp(
    `(?<![A-Za-z0-9])(?:${unique.map(escapeRegExp).join("|")})(?![A-Za-z0-9])`,
    "g",
  );
  const parts: TextSegment[] = [];
  let last = 0;
  for (const match of text.matchAll(pattern)) {
    const index = match.index ?? 0;
    if (index > last) parts.push({ text: text.slice(last, index), flagged: false });
    parts.push({ text: match[0], flagged: true });
    last = index + match[0].length;
  }
  if (last < text.length) parts.push({ text: text.slice(last), flagged: false });
  return parts.length > 0 ? parts : [{ text, flagged: false }];
}
